import * as types from "./mutation-types";
import { plenaria_empty } from "./getters";

export default {
  [types.SET_PLENARIAS](state, payload) {
    state.plenarias = payload;
  },
  [types.SET_PLENARIA](state, payload) {
    payload = Object.assign(plenaria_empty(), payload);
    state.plenaria = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
  [types.SET_PRESENCAS](state, payload) {
    state.presencas = payload;
  },
};
